import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#2CB7B1",
        success: "#27AE60",
        error: "#E74C3C",
        warning: "#F4B740",
        info: "#3498DB",
      },
    },
  },
});
